import { useEffect, useState } from 'react'

import {
  Avatar,
  CardHeader,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { getInitials } from '../../helpers/getInitials'

import { ArrowLeft } from 'lucide-react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import iconWhatsApp from '../../assets/whatsapp.svg'
import ContactAvatarModal from '../ContactAvatarModal'
import { useStyles } from './style'

const TicketInfo = ({
  onClick,
  contact,
  ticket,
  isDrawerOpen
  //allTags = []
}) => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { user } = ticket
  const [, setUserName] = useState('')
  const [contactName, setContactName] = useState('')
  // const [anchorEl] = useState(null)

  const [openAvatarModal, setOpenAvatarModal] = useState(false)

  const getDisplayContactName = currentContact => {
    if (!currentContact) return ''

    const baseName = (currentContact.name || '').trim()
    const apelido = (currentContact.apelido || '').trim()
    const pessoaNormalized = `${currentContact.pessoa || ''}`
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()

    if (pessoaNormalized === 'juridica' && apelido) {
      return `${baseName} (${apelido})`
    }

    return baseName
  }

  useEffect(() => {
    if (user) {
      setUserName(user.name)
    }
    if (contact) {
      setContactName(getDisplayContactName(contact))
    }
  }, [user, contact])

  // const open = Boolean(anchorEl)
  // const id = open ? 'simple-popover' : undefined

  useEffect(() => {
    if (contact) {
      const displayContactName = getDisplayContactName(contact)
      setContactName(displayContactName)
      if (document.body.offsetWidth < 600) {
        if (displayContactName.length > 10) {
          const truncadName = displayContactName.substring(0, 10) + '...'
          setContactName(truncadName)
        }
      }
    }

    if (user && contact) {
      // setUserName(`${i18n.t('messagesList.header.assignedTo')} ${user.name}`)

      if (document.body.offsetWidth < 600) {
        setUserName(`${user.name}`)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCloseOrOpenAvatar = () => {
    setOpenAvatarModal(false)
  }

  const handleNameClick = event => {
    event.preventDefault()
    event.stopPropagation()
    onClick()
  }

  const getTicketProtocol = currentTicket => {
    if (!currentTicket) return ''

    if (currentTicket.protocol) {
      return currentTicket.protocol
    }

    if (!currentTicket.id) return ''

    const baseDate = currentTicket.createdAt
      ? new Date(currentTicket.createdAt)
      : new Date()

    if (Number.isNaN(baseDate.getTime())) {
      return String(currentTicket.id)
    }

    const day = String(baseDate.getDate()).padStart(2, '0')
    const month = String(baseDate.getMonth() + 1).padStart(2, '0')
    const year = baseDate.getFullYear()

    return `${day}${month}${year}-${currentTicket.id}`
  }

  const ticketProtocol = getTicketProtocol(ticket)

  return (
    <>
      <div
        className={
          isMobile
            ? classes.mainHeaderContainerMobile
            : classes.mainHeaderContainer
        }
      >
        {isMobile && (
          <IconButton
            size="small"
            onClick={() => history.push('/tickets')}
            className={classes.backButton}
          >
            <ArrowLeft />
          </IconButton>
        )}
        <CardHeader
          className={classes.cardHeader}
          titleTypographyProps={{ noWrap: true }}
          subheaderTypographyProps={{ noWrap: true }}
          avatar={
            <div className={classes.boxAvatar}>
              {isMobile && (
                <div className={classes.whatsappBadge}>
                  <img src={iconWhatsApp} width="14" alt="zap" />
                </div>
              )}
              <Tooltip
                title={
                  isDrawerOpen
                    ? 'Fechar Informações do Contato'
                    : 'Abrir Informações do Contato'
                }
              >
                <Avatar
                  // onClick={() => setOpenAvatarModal(true)}
                  onClick={handleNameClick}
                  className={classes.cardAvatar}
                  src={contact.profilePicUrl}
                  alt={`Imagem de ${contact.name}`}
                >
                  {getInitials(contact?.name)}
                </Avatar>
              </Tooltip>
            </div>
          }
          title={
            <div className={classes.cardSubHeader}>
              <Tooltip
                title={
                  isDrawerOpen
                    ? 'Fechar Informações do Contato'
                    : 'Abrir Informações do Contato'
                }
              >
                <span
                  className={classes.cardTitle}
                  onClick={handleNameClick}
                >{`${contactName}`}</span>
              </Tooltip>
              <span className={classes.ticketID}>
                {isMobile ? contact.number : `Protocolo: ${ticketProtocol}`}
              </span>
            </div>
          }
        />

        <ContactAvatarModal
          open={openAvatarModal}
          onClose={() => {
            handleCloseOrOpenAvatar()
          }}
          avatarUrl={contact.profilePicUrl}
          alt={`Imagem de ${contact.name}`}
          contactId={contact?.id}
          onAvatarUpdate={() => { }} // Callback vazio, pode ser implementado se necessário
        />
      </div>
    </>
  )
}

export default TicketInfo